// src/components/ChangePasswordModal.js
import { useState } from 'react';
import API from '../api/axios';
import './ChangePasswordModal.css';

const ChangePasswordModal = ({ onClose }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Yeni şifreler eşleşmiyor');
      return;
    }

    try {
      const res = await API.put('/auth/change-password', { oldPassword, newPassword });
      setSuccess(res.data.message);
      setTimeout(onClose, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Bir hata oluştu');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h2>Şifre Değiştir</h2>
        {success ? (
          <p className="success-msg">{success}</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Eski Şifre</label>
              <input
                type="password"
                className="modal-input"
                value={oldPassword}
                onChange={e => setOldPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label>Yeni Şifre</label>
              <input
                type="password"
                className="modal-input"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label>Yeni Şifre (Tekrar)</label>
              <input
                type="password"
                className="modal-input"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            {error && <p className="error-msg">{error}</p>}
            <button type="submit" className="save-btn">Kaydet</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ChangePasswordModal;